import {
    Box, Button, ButtonGroup, Card, Dialog, DialogActions, DialogContent, DialogTitle,
    TextField, Icon, Typography
} from '@mui/material';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import React, { useEffect, useState } from 'react';
import AptaTable from 'examples/AptaTable';
import axios from 'axios';
import { URL } from 'constants/constant';
import Swal from 'sweetalert2';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';


const EventInfo = () => {
    const [details, setDetails] = useState({ title: "", description: "" });
    const [open, setOpen] = useState(false);
    const [events, setEvents] = useState([]);
    const [formType, setFormType] = useState('add');

    const handleOpen = (type, item = { title: "", description: "" }) => {
        setFormType(type);
        setDetails(item);
        setOpen(true);
    };

    const handleClose = () => setOpen(false);

    const handleSave = async (data) => {
        console.log({ data });

        try {
            if (formType === 'add') {
                await axios.post(`${URL}/api/admin/iria/event-info/create`, data);
                Swal.fire("Event created!");
            } else {
                await axios.put(`${URL}/api/admin/iria/event-info/edit/${data._id}`, data);
                Swal.fire("Event updated!");
            }
            handleClose();
            getEvents();
        } catch (error) {
            Swal.fire("Something went wrong!");
            console.error("Save error:", error);
        }
    };

    const handleDelete = async (id) => {
        try {
            await axios.delete(`${URL}/api/admin/iria/event-info/delete/${id}`);
            Swal.fire("Deleted successfully!");
            getEvents();
        } catch (error) {
            console.error("Delete error:", error);
        }
    };

    const getEvents = async () => {
        try {
            const res = await axios.get(`${URL}/api/admin/iria/event-info/get-all`);
            setEvents(res.data || []);
        } catch (err) {
            console.log(err.message);
        }
    };

    useEffect(() => {
        getEvents();
    }, []);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Box display="flex" mb={3} justifyContent="end">
                <Button
                    startIcon={<Icon>add</Icon>}
                    variant="contained"
                    color="primary"
                    style={{ color: 'white' }}
                    onClick={() => handleOpen('add')}
                >
                    Add Event
                </Button>
            </Box>

            <AptaTable
                columns={['Title', 'Actions']}
                rows={events?.map((item) => ({
                    Title: item?.title,
                    Actions: (
                        <ButtonGroup size='small'>
                            <Button color='info' onClick={() => handleOpen('edit', item)}>
                                <Icon color='info'>edit</Icon>
                            </Button>
                            <Button color="error" onClick={() => handleDelete(item?._id)}>
                                <Icon color='error'>delete</Icon>
                            </Button>
                        </ButtonGroup>
                    ),
                }))}
            />


            <InputFormModal
                open={open}
                onClose={handleClose}
                onSave={handleSave}
                details={details}
                type={formType}
                setDetails={setDetails}
            />
        </DashboardLayout>
    );
};

export default EventInfo;

const InputFormModal = ({ open, onClose, onSave, details, setDetails, type }) => {
    console.log('int');

    // useEffect(() => {
    //     if (details) {
    //         setDetails({ ...details });
    //     }
    // }, [details]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        console.log('chnage');
        setDetails({ ...details, title: value });
    };

    const handleQuillChange = (value) => {

        setDetails({ ...details, description: value });
    };

    const handleSave = () => {
        onSave(details);
    };
    console.log(details.title, details.title);

    return (
        <Dialog open={open} maxWidth="lg" fullWidth onClose={onClose}>
            <DialogTitle>{type === 'add' ? 'Add Event Info' : 'Edit Event Info'}</DialogTitle>
            <DialogContent>
                <TextField
                    label="Title"
                    name="title"
                    value={details.title}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                />
                <Typography variant="subtitle1" gutterBottom>Description</Typography>
                <ReactQuill
                    value={details.description || ''}
                    onChange={handleQuillChange}
                    theme="snow"
                    style={{ height: 400, marginBottom: 20 }}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Cancel
                </Button>
                <Button
                    onClick={handleSave}
                    color="primary"
                    variant="contained"
                    style={{ color: 'white' }}
                    disabled={!details.title || !details.description}
                >
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
};

